export const MAX_CHANNEL_LINKS_ALLOWED = 3
